import { useRecoilState } from "recoil";
import { ModelSkuSelection } from "src/modules/ModelSkuSelection/ModelSkuSelection";
import { costComparisonModel2GlobalState } from "src/recoil/costExplosionAtoms";

type Props = {
  disabled?: boolean;
};

export const SkuSelectionModel2Tab: React.FC<Props> = (props: Props) => {
  const [stateData, setStateData] = useRecoilState(
    costComparisonModel2GlobalState
  );

  return (
    <ModelSkuSelection
      disabled={props.disabled}
      stateData={stateData}
      stateDataSetter={setStateData}
    />
  );
};
